var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPackageOutline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_5268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.374 4.58759L10.672 0.373362C10.2537 0.142229 9.74598 0.142229 9.32766 0.373362L1.62565 4.58934C1.17766 4.83446 0.898617 5.304 0.897461 5.81467V14.1854C0.898617 14.696 1.17766 15.1656 1.62565 15.4107L9.32766 19.6267C9.74598 19.8578 10.2537 19.8578 10.672 19.6267L18.374 15.4107C18.822 15.1656 19.1011 14.696 19.1022 14.1854V5.81554C19.102 5.30394 18.8229 4.83316 18.374 4.58759ZM9.99984 1.59868L17.0314 5.44969L14.4259 6.87631L7.39341 3.02531L9.99984 1.59868ZM9.99984 9.30071L2.96825 5.44969L5.93528 3.82527L12.9669 7.67628L9.99984 9.30071ZM2.29783 6.67501L9.29966 10.5068V18.0154L2.29783 14.1862V6.67501ZM17.7019 14.1827L10.7 18.0154V10.5103L13.5008 8.97774V12.1014C13.5008 12.6404 14.0843 12.9773 14.551 12.7078C14.7677 12.5827 14.9011 12.3516 14.9011 12.1014V8.21104L17.7019 6.67501V14.1819V14.1827Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_5268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPackageOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Package-outline.9793d04f.svg";
export { ForwardRef as ReactComponent };